import { showNotification } from 'Store/Notification/Notification.action';
import { QueryDispatcher } from 'Util/Request';

import GoogleTagManagerQuery from '../../query/GoogleTagManager.query';
import { updateConfig } from './GoogleTagManager.action';

/** @namespace GtmNew/Store/GoogleTagManager/Dispatcher */
export class GoogleTagManagerDispatcher extends QueryDispatcher {
    __construct() {
        super.__construct();
    }

    onSuccess({ gtm }, dispatch) {
        if (gtm) {
            dispatch(updateConfig({ gtm }));
        }
    }

    onError(error, dispatch) {
        dispatch(showNotification('error', 'Error fetching GoogleTagManager!', error));
    }

    prepareRequest() {
        return GoogleTagManagerQuery.getGTMConfiguration();
    }
}

export default new GoogleTagManagerDispatcher();
